module.exports = __webpack_public_path__ + "img/5E5F62_A7B2BE_211C17_939CA3-256px.3683aa2d.png";